<template>
  <v-tabs class="mb-5" color="primary" slider-color="blue-darken-3">
    <v-tab :to="{ name: 'registration-journal-general-info' }" replace>
      Загальні дані
    </v-tab>
    <v-tab :to="{ name: 'registration-journal-definitions' }" replace>
      Типи документів
    </v-tab>
    <v-tab :to="{ name: 'registration-journal-departments' }" replace>
      Підрозділи
    </v-tab>
    <v-tab :to="{ name: 'registration-journal-accesses' }" replace>
      Доступи
    </v-tab>
  </v-tabs>
</template>

<script lang="ts">
export default {
  name: 'RegistrationJournalTabs',
}
</script>
